App.directive('bottomInfo', ['$window', '$cookies', '$timeout', function ($window, $cookies, $timeout) {
    return {
        link: link,
        restrict: 'AEC',
        scope: {}
    };

    function link(scope, elem, attrs) {
        scope.isAccept = $cookies.get('accept');

        function onResize() {
            var $_cookies = $('.cookies');
            var cookiesHeight = $_cookies.innerHeight();
            if ($_cookies.hasClass('ng-hide')) {
                cookiesHeight = 0;
            }
            elem[0].style['bottom'] = cookiesHeight + 'px';
        }

        angular.element(document).ready(function () {
            onResize();
        });

        angular.element($window).on('resize', function () {
            onResize();
        });
    };
}]);